const breadCrumb = "Lotação de Servidores - Manutenção de Servidores";

const routes = [
  {
    path: "servidor/:servidorId/informacoes-complementares-servidor",
    name: "informacoes-complementares-servidor",
    meta: {
      allowedPermissions: ["servidor_info_complementar_show"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ManutencaoInformacoesComplementaresServidor/InformacoesComplementaresServidorCad.vue"
      ),
  },
];

export default routes;
